import { Link } from "react-router-dom";
import { ArrowDownRight, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative min-h-[100svh] w-full text-[var(--bone)] overflow-hidden bg-[var(--forest)]">
      {/* Ticker */}
      <div className="absolute top-0 left-0 right-0 border-b border-[var(--bone)]/15 backdrop-blur-sm bg-black/30 z-20">
        <div className="container-x py-2 flex flex-wrap items-center justify-between text-[10px] font-mono tracking-[0.2em] uppercase text-[var(--bone)]/80 gap-3">
          <span>STEM · Especially the girls</span>
          <span className="hidden md:inline">Founded 2019 · Africa · Nigeria</span>
          <span className="text-[var(--terracotta)]">Donations opening soon</span>
        </div>
      </div>

      <div className="grain absolute inset-0 opacity-50 z-0" />

      {/* Big decorative numeral background */}
      <div aria-hidden className="hidden md:block absolute -right-40 top-1/2 -translate-y-1/2 font-serif text-[55rem] leading-none text-[var(--bone)]/[0.04] select-none z-0">
        I
      </div>

      <div className="relative z-10 container-x min-h-[100svh] flex flex-col justify-center pt-32 pb-12">
        <div className="max-w-5xl fade-up">
          <div className="overline text-[var(--terracotta)] mb-7">A non-profit · Africa · Nigeria</div>
          <h1 className="font-serif text-[3rem] leading-[0.9] sm:text-7xl md:text-[7.5rem] lg:text-[9rem] tracking-[-0.04em]">
            Rebuilding<br/>schools.<br/>Restoring<br/><em className="text-[var(--terracotta)] not-italic">curiosity.</em>
          </h1>
          <p className="mt-10 text-[var(--bone)]/85 leading-relaxed text-base md:text-lg max-w-2xl">
            Irene Foundation works across Africa — especially Nigeria — to rebuild safe,
            modern classrooms and put hands-on STEM in the hands of every student.
            <span className="text-[var(--terracotta)] font-medium"> Especially the girls.</span>
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <Link to="/volunteer" data-testid="hero-volunteer-btn" className="btn-primary text-base">
              Volunteer with us <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/partner" data-testid="hero-partner-link" className="btn-ghost-light text-sm">
              Partner with us <ArrowDownRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom info bar */}
      <div className="relative z-10 border-t border-[var(--bone)]/15 bg-black/30 backdrop-blur-sm">
        <div className="container-x py-4 flex flex-col md:flex-row justify-between gap-3 text-xs font-mono uppercase tracking-[0.15em] text-[var(--bone)]/70">
          <span>Lagos · Ibadan · partners across Africa</span>
          <span className="text-[var(--terracotta)]">Scroll to meet the kids ↓</span>
        </div>
      </div>
    </section>
  );
}
